import 'javascripts/all_pages.js'
import 'javascripts/all_theme_styles.js'
import { comparisonWidget } from "javascripts/product_comparisons/comparison_widget";

/* stylesheet */
// import 'stylesheets/product_comparisons/index.scss'

comparisonWidget();